<template>
    <base-side-bar
        ><div
            class="flex flex-col items-center justify-center flex-grow w-full mx-10"
        >
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Charges du personnel
            </h2>
            <br />
            <wide-card>
                <multiselect
                    v-model="fonctions"
                    tag-placeholder="Add this as new tag"
                    placeholder="Vous pouvez ajouter une ou plusieurs professions"
                    label="name"
                    track-by="code"
                    :options="options"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                ></multiselect>

                <div
                    v-for="(fonction, index) in fonctions"
                    :key="fonction.code"
                >
                    <label
                        class="block my-2 text-sm font-semibold leading-5 tracking-wide text-gray-600 sm:semibold sm:text-base sm:leading-10"
                        >{{ fonction.name }}</label
                    >
                    <div class="flex -mt-6">
                        <base-number-input
                            label="Effectif"
                            v-model="fonction.effective"
                            :hasError="$v.fonctions[`${index}`].$error"
                            :errorMessage="
                                errorMessage(
                                    fonction.name,
                                    $v.fonctions[`${index}`].effective
                                )
                            "
                            @blur="$v.fonctions[`${index}`].effective.$touch()"
                        />
                        <base-number-input
                            label="Salaire mensuel (brut)"
                            :isCurrency="true"
                            v-model="fonction.salary"
                            :hasError="$v.fonctions[`${index}`].$error"
                            :errorMessage="
                                errorMessage(
                                    fonction.name,
                                    $v.fonctions[`${index}`].salary
                                )
                            "
                            @blur="$v.fonctions[`${index}`].salary.$touch()"
                        /><base-number-input
                            label="Nombre de mois"
                            v-model="fonction.monthNumber"
                            :hasError="$v.fonctions[`${index}`].$error"
                            :errorMessage="
                                errorMessage(
                                    fonction.name,
                                    $v.fonctions[`${index}`].monthNumber
                                )
                            "
                            @blur="
                                $v.fonctions[`${index}`].monthNumber.$touch()
                            "
                        />
                    </div>
                </div>
            </wide-card>

            <wide-card
                title="Total charges du personnel (HT)"
                titleClass="text-center mb-2"
                :info="true"
                @modal="isOpen = !isOpen"
            >
                <base-number-input
                    label="Taux d’évolution %"
                    v-model="tauxDevolution"
                    :hasError="$v.tauxDevolution.$error"
                    :errorMessage="
                        errorMessage('Taux d\'évolution', $v.tauxDevolution)
                    "
                    @blur="$v.tauxDevolution.$touch()"
                />
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ totalFonctions }}
                    </h2>
                </div>
                <base-info-modal @modal-close="isOpen = false" :open="isOpen">
                    <!-- Modal Content -->
                    <article class="prose lg:prose-sm">
                        <!-- Emploi -->
                        <h1>Emploi</h1>
                        <h3>
                            Salaire minimum interprofessionnel garanti (SMIG) et
                            salaire minimum agricole garanti (SMAG) - A partir
                            du 1er juillet 2020
                        </h3>
                        <ul>
                            <li>
                                Le SMIG est de l’ordre de 2828,71dirhams/mois
                                sur la base de 191 heures de travail par mois.
                            </li>
                            <li>Le SMAG journalier est de 76,70 DH</li>
                            <blockquote>
                                Source : Ministère de l’Emploi et de la
                                formation professionnelle
                            </blockquote>
                        </ul>
                        <h3>Majoration des heures supplémentaires</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>Secteur</th>
                                    <th colspan="3">Secteur non agricole</th>
                                    <th colspan="2">Secteur agricole</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Plage horaire</td>
                                    <td>6H à 21H heures</td>
                                    <td>21H à 6H</td>
                                    <td colspan="2">5H à 20H</td>
                                    <td>20H à 5H</td>
                                </tr>
                                <tr>
                                    <td>Taux appliqué</td>
                                    <td>25%</td>
                                    <td>50%</td>
                                    <td colspan="2">25%</td>
                                    <td>50%</td>
                                </tr>
                                <tr>
                                    <td>
                                        Taux appliqué si le travail
                                        supplémentaire a été effectué lors d’un
                                        jour de repos hebdomadaire
                                    </td>
                                    <td>50%</td>
                                    <td>100%</td>
                                    <td colspan="2">50%</td>
                                    <td>100%</td>
                                </tr>
                            </tbody>
                        </table>
                        <blockquote>
                            Source : Art 201 du code de travail
                        </blockquote>
                        <!-- / Emploi -->
                        <!-- CNSS -->
                        <h1>
                            Charges Sociales : Caisse de la sécurité sociale
                            (CNSS)
                        </h1>
                        <h3>Taux appliqués sauf les marins et les pécheurs</h3>
                        <p>
                            Les cotisations dues à la CNSS sont assises sur
                            l’ensemble des rémunérations perçues par les
                            bénéficiaires du régime de sécurité sociale, y
                            compris les indemnités, primes, gratifications et
                            tout autre avantage en argent ou en nature, ainsi
                            que toute somme perçue directement ou par
                            l’entremise d’un tiers à titre de pourboire. Ces
                            rémunérations constituent ce que l’on appelle
                            l’assiette des cotisations, base sur laquelle sont
                            calculées les cotisations.
                        </p>
                        <table>
                            <thead>
                                <tr>
                                    <th>Catégorie de prestation</th>
                                    <th>Base de calcul</th>
                                    <th>Taux Charge patronale</th>
                                    <th>Taux Charge Salariale</th>
                                    <th>Taux Global</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1- Prestations Familiales</td>
                                    <td>
                                        Le total des salaires réels de la
                                        période (mois/trimestre)
                                    </td>
                                    <td>6,40%</td>
                                    <td>--</td>
                                    <td>6,40%</td>
                                </tr>
                                <tr>
                                    <td>
                                        2- Prestations sociales à court terme
                                    </td>
                                    <td>
                                        Le total des salaires plafonnés (chacun
                                        plafonné à 6000 dhs)
                                    </td>
                                    <td>1,05%</td>
                                    <td>0,52%</td>
                                    <td>1,57%</td>
                                </tr>
                                <tr>
                                    <td>
                                        3- Prestations sociales à long terme
                                    </td>
                                    <td>
                                        Le total des salaires plafonnés (chacun
                                        plafonné à 6000 dhs)
                                    </td>
                                    <td>7,93%</td>
                                    <td>3,96%</td>
                                    <td>11,89%</td>
                                </tr>
                                <tr>
                                    <td>4- Assurance Maladie Obligatoire</td>
                                    <td>
                                        Le total des salaires réels de la
                                        période (mois/trimestre)
                                    </td>
                                    <td>4,11%</td>
                                    <td>2,26%</td>
                                    <td>6,37%</td>
                                </tr>
                                <tr>
                                    <td>
                                        5- Taxe de formation professionnelle
                                    </td>
                                    <td>
                                        Le total des salaires réels de la
                                        période (mois/trimestre)
                                    </td>
                                    <td>1,60%</td>
                                    <td>--</td>
                                    <td>1,60%</td>
                                </tr>
                                <tr>
                                    <td>Total :</td>
                                    <td></td>
                                    <td>21,09</td>
                                    <td>6,74%</td>
                                    <td>27,83%</td>
                                </tr>
                            </tbody>
                        </table>
                        <blockquote>Source : CNSS</blockquote>
                        <h3>Activités des marins et les pécheurs</h3>
                        <p>
                            La cotisation au titre du régime général et de l’AMO
                            est assise sur les recettes brutes du total du
                            produit de la vente du poisson pêché. Les taux de
                            cotisation appliqués sont fixés comme suit :
                        </p>
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>
                                        Taux de cotisation au titre du régime
                                        général
                                    </th>
                                    <th>
                                        Taux de cotisation au titre du régime
                                        AMO
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Chalutiers</td>
                                    <td>4,65%</td>
                                    <td>1,36%</td>
                                </tr>
                                <tr>
                                    <td>Sardiniers</td>
                                    <td>6%</td>
                                    <td>1,70%</td>
                                </tr>
                            </tbody>
                        </table>
                        <blockquote>Source : CNSS</blockquote>
                        <!-- / CNSS -->
                    </article>
                    <!-- / Modal Content -->
                    <!-- <p class="text-sm leading-5 text-gray-500">
            Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.
                  </p>-->
                </base-info-modal>

                <base-info-modal
                    @modal-close="validation = false"
                    :open="validation"
                ></base-info-modal>
            </wide-card>

            <base-primary-button title="Suivant" @click="nextStep" /></div
    ></base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import { mapState } from "vuex";
import {
    required,
    decimal,
    minValue,
    maxValue
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        WideCard
    },

    created() {
        this.$store.dispatch("forms/showSection", "Étude Financiere");
        this.$store.dispatch("forms/stepFocus", "Charges du personnel");
    },
    mounted() {
        this.fonctions = this.$store.getters[
            "EtudeFinanciere/labourCharges"
        ].laboursCharge;
        this.tauxDevolution = this.$store.getters[
            "EtudeFinanciere/labourCharges"
        ].tauxDevolution;
    },
    data() {
        return {
            fonctions: [],

            tauxDevolution: null,
            isOpen: false,
            validation: false
        };
    },
    mixins: [errorMessage, scrollToError],
    validations() {
        let Validation = {
            tauxDevolution: {
                required,
                decimal,
                minValue: minValue(0),
                maxValue: maxValue(100)
            }
        };
        if (this.fonctions.length !== 0) {
            let array = this.fonctions.map((element, index) => {
                return {
                    [`${index}`]: {
                        effective: {
                            required,
                            minValue: minValue(1)
                        },
                        salary: {
                            required,
                            decimal,
                            minValue: minValue(1)
                        },
                        monthNumber: {
                            required,
                            decimal,
                            maxValue: maxValue(12),
                            minValue: minValue(1)
                        }
                    }
                };
            });

            let validation = {
                ...Object.assign({}, {}, ...array)
            };
            return { fonctions: validation, ...Validation };
        }
        return Validation;
    },
    methods: {
        nextStep() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch("EtudeFinanciere/addFonctions", {
                    details: this.fonctions,
                    tauxDevolution: this.tauxDevolution,
                    total: this.totalFonctions
                });
                this.$store
                    .dispatch("EtudeFinanciere/SaveFonctions")
                    .then(() => {
                        this.$store.dispatch(
                            "forms/subStepComplete",
                            "Charges du personnel"
                        );
                        this.$store.dispatch(
                            "forms/completeBigStep",
                            "Étude Financiere"
                        );
                        this.$store.dispatch("user/validation").then(() => {
                            this.$router.push({
                                name: "validation",
                                params: {
                                    uid: `${this.$store.state.user.bpiId}`
                                }
                            });
                        });
                    });
            } else {
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: new Date().getTime(),
                effective: null,
                salary: null,
                monthNumber: 12
            };
            this.options.push(tag);
            this.fonctions.push(tag);
        }
    },
    computed: {
        ...mapState("forms", {
            options: state => state.ChargesDuPersonnel.options
        }),
        totalFonctions() {
            if (this.fonctions.length === 0) return 0;

            return this.fonctions.reduce((a, b) => {
                if (
                    b.salary === null ||
                    b.effective == null ||
                    b.monthNumber == null
                )
                    return a;
                return (
                    a +
                    parseInt(b.salary) *
                        parseInt(b.effective) *
                        parseInt(b.monthNumber)
                );
            }, 0);
        }
    }
};
</script>

<style></style>
